export function allocationCommand(allocation, targetId, amount) {
    return {
        id: `allocate:${allocation.id}:${targetId}`,
        execute: (transaction) => assign(transaction, allocation, targetId, amount),
    };
}
export function validateAllocations(transaction, allocations) {
    const numbers = transaction.numbers;
    for (const allocation of allocations) {
        let assigned = numbers.fromNumber(0);
        for (const target of allocation.targets) {
            assigned = numbers.add(assigned, transaction.getAllocation(allocation.id, target));
        }
        const budget = transaction.get(allocation.budget);
        if (numbers.cmp(assigned, budget) > 0) {
            transaction.reject({
                code: "allocation-exceeded",
                allocationId: allocation.id,
                assigned,
                budget,
            });
        }
    }
}
function assign(transaction, allocation, targetId, amount) {
    if (!transaction.isScopeActive(allocation.scope))
        transaction.reject({ code: "disabled", actionId: allocation.id, reasonKey: "scope-inactive" });
    const numbers = transaction.numbers;
    const zero = numbers.fromNumber(0);
    if (!allocation.targets.includes(targetId)) {
        transaction.reject({ code: "invalid-target", id: `${allocation.id}:${targetId}` });
    }
    if (!numbers.isFinite(amount) || numbers.cmp(amount, zero) < 0) {
        transaction.reject({ code: "invalid-count", requested: amount });
    }
    let assigned = zero;
    for (const target of allocation.targets) {
        assigned = numbers.add(assigned, target === targetId ? amount : transaction.getAllocation(allocation.id, target));
    }
    const budget = transaction.get(allocation.budget);
    if (numbers.cmp(assigned, budget) > 0) {
        transaction.reject({
            code: "allocation-exceeded",
            allocationId: allocation.id,
            assigned,
            budget,
        });
    }
    transaction.setAllocation(allocation.id, targetId, amount);
}
//# sourceMappingURL=allocations.js.map